import { Controller } from "stimulus";
import React from "react";
import ReactDOM from "react-dom";
import Products from "~/scripts/components/Products";

export default class extends Controller {
    connect() {
        ReactDOM.render(<Products />, this.element);
    }
}



// WEBPACK FOOTER //
// ./public/assets/scripts/controllers/products-controller.js